import { Routes, Route } from "react-router-dom";
import { Routes as routes } from "./Routes";


export const AppRoute = () => {
    return (
        <>
            <Routes>
                {routes.map((route, i) => (
                    <Route exact={route.exact} key={i} path={route.path} element={route.component}></Route>
                ))}
            </Routes>
        </>
    );
};
